function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgParaASuaCasa = function SvgParaASuaCasa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.318 8.748a2 2 0 001.352 3.024l1.347.237v4.153h1v-3.977l2 .353v7.624h-1.75a2 2 0 00-2 2v2h11.5v-2a2 2 0 00-2-2h-1.75v-6.919l3.54.624a2 2 0 002.305-2.378L18.043 2.79a2 2 0 00-1.61-1.56L11.047.28A2 2 0 009 1.197L4.318 8.748zm8.699 11.414v-7.095l-2-.353v7.448h2zm5.866-8.468a1 1 0 01-1.153 1.189L5.844 10.787a1 1 0 01-.676-1.512l4.683-7.552a1 1 0 011.023-.457l5.386.95a1 1 0 01.805.78l1.818 8.698zM7.267 23.162v-1a1 1 0 011-1h7.5a1 1 0 011 1v1h-9.5z",
    fill: props.color
  }));
};
SvgParaASuaCasa.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgParaASuaCasa.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgParaASuaCasa;